// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
import { useEntity } from '../helpers/use-entity'
import { Container } from '@uswitch/ev-core/react'
import MoneyHomePageHero from '@uswitch/ev-components/lib/components/elements/hero'

import { cf2imgix } from '../helpers/imgix-image'
import Breadcrumbs from '../breadcrumbs.connected'
import Grid from './grid-from-json.connected'

const ConnectedMoneyHomePageHero = (props) => {
  const image = useEntity(props.image)

  const imagePosition = {
    position: {
      bottom: 0,
      right: 0,
      transform: 'scale(1.4) translate(40%, 5%)',
    },
    imageType: 'img',
    displayOnMobile: true,
  }

  const breadcrumbs = <Breadcrumbs entity={props.breadcrumbs} />

  return (
    <MoneyHomePageHero
      breadcrumbs={props.breadcrumbs && breadcrumbs}
      container={Container}
      fgImage={cf2imgix(image?.file?.url)}
      fgImagePosition={imagePosition.position}
      fgImageType={imagePosition.imageType}
      fgImageOnMobile={imagePosition.displayOnMobile}
    >
      <Grid {...props} />
    </MoneyHomePageHero>
  )
}

export default (props) => <ConnectedMoneyHomePageHero {...props} />
